class DocumentationComment {

    constructor() {

        this._template = null;
        this._popUpEditCommentTemplate = null;
        this._commentsData = new CommentsData();
        this._commentsUtils = new CommentsUtils();

        this._loadTemplates();

    }

    _loadTemplates() {

        this._template = Handlebars.compile($("#documentComment").html());
        this._popUpEditCommentTemplate = Handlebars.compile($("#editCommentPopUp").html());

    }

    _enableHandlers() {

        $("#comments-tab").on("click.commentsTab", this._commentsUtils.setThreadLineHeight.bind(this));
        $("div.comments-tab").on("click.showDataList", "span.comment-view-likes-button", documentationScreenController.drawDocumentUsersSocialActivityScreen.bind(documentationScreenController));
        $("div.comments-tab").on("click.markCommentAsILiked", "div.mark-comment-liked", this._onToggleLikeComment.bind(this));
        $("div.comments-tab").on("click.commentReply", "span.comment-reply-button", this._onClickReplyToComment.bind(this));
        $("div.comments-tab").on("click.editComment", "span.comment-edit-button", this._onClickEditComment.bind(this));
        $("div.comments-tab").on("click.removeComment", "span.comment-delete-button", this._onClickDeleteComment.bind(this))
        $("div.comments-tab").on("click.commentUserProfile", ".open-profile-button", this._onclickUser.bind(this));
        $("div.reply-to-comment-header > .close-button").on("click.removeReply", this._onClickRemoveReplyToComment.bind(this));

    }

    enableMentions(textArea, mentionsList, mentionsListContent, mentionsListItem, defaultValue="") {

        function _onDataRequest(mode, query, callback) {

            api.getMentionsList(null, null, query, function(response) {

                const data = _.map(response.result.friends, 'friend');

                _.forEach(data, function(user) {
                    user.icon = user.user_icon;
                    user.level_icon = user.level.icon;
                    user.level_color = user.level.color;
                })

                callback.call(this, data);

            });

        }

        const $mentionsTextarea = textArea;

        $mentionsTextarea.mentionsInput({
            onDataRequest: _onDataRequest,
            minChars: 0,
            elastic: false,
            templates: {
                mentionItemHighlight: _.template('<strong class="world_color_1"><span><%= value %></span></strong>'),
                mentionItemSyntax: _.template('@{<%= id %>}'),
            },
            jquerySelectors: {
                mentionsList: mentionsList,
                mentionsListContent:  mentionsListContent,
                mentionsListItem: mentionsListItem
            },
            defaultValue: defaultValue
        });

        $mentionsTextarea.autogrow({vertical: true, horizontal: false});

    }

    _drawCommentsList() {

        const $commentsTab = $("#document-details-content div.comments-tab");
        const that = this;
        let commentsList = this._commentsData.getCommentsList();

        commentsList = DocumentationUtils.formatCommentsDate(commentsList);

        _.forEach(commentsList, function(comment) {
            comment.formatComment = DocumentationUtils.formatCommentMentions(comment.comment, comment.mentions, comment.author_data ? comment.author_data.user_world_id : null);
        });

        $commentsTab.html(documentationScreenController.documentCommentsTab({
            world: world,
            user: user,
            commentsList: commentsList,
            socialActivityTypes: new SocialActivitiesTypes().getTypes(),
            showEmptyCommentsMessage: true
        }));

        this._commentsUtils.setThreadLineHeight();

    }

    drawMoreComments(commentsList) {

        const $commentsTab = $("#document-details-content div.comments-tab");
        const that = this;
        const currentCommentsList = this._commentsData.getCommentsList();

        commentsList = DocumentationUtils.formatCommentsDate(commentsList);

        _.forEach(commentsList, function(comment) {
            comment.formatComment = DocumentationUtils.formatCommentMentions(comment.comment, comment.mentions, comment.author_data ? comment.author_data.user_world_id : null);
        });

        this._commentsData.setCommentsList(_.concat(currentCommentsList, commentsList));

        $commentsTab.append(documentationScreenController.documentCommentsTab({
            world: world,
            user: user,
            commentsList: commentsList,
            socialActivityTypes: new SocialActivitiesTypes().getTypes(),
            showEmptyCommentsMessage: false
        }));

        this._commentsUtils.setThreadLineHeight();

    }

    drawComment(commentData) {


        const $commentsTab = $("#document-details-content div.comments-tab");
        const formatCommentDate = formatToDateSystem(commentData.date);
        const commentsList = this._commentsData.getCommentsList();
        const $emptyDataInfo = $("div.comments-tab > div.empty-data-info");

        commentData.formatComment = DocumentationUtils.formatCommentMentions(commentData.unalteredComment, commentData.mentions, commentData.user_world_id);
        commentData.formatDate = formatCommentDate;
        commentsList.push(commentData);

        this._commentsData.setCommentsList(commentsList);

        const context = {
            world: world,
            user: user,
            commentData: commentData,
            socialActivityTypes: new SocialActivitiesTypes().getTypes(),
        }

        if (!commentData.response_to_id) {

            $commentsTab.prepend(
                "<div class='comment-thread' data-thread=" + commentData.comment_id + ">" +
                    "<div class='thread-line'></div>" +
                    this._template(context) +
                "</div>");

        } else {

            const $commentThread = $(".comment-thread[data-thread=" + commentData.response_to_id + "]");
            $commentThread.find(".document-comment").first().after(this._template(context));

        }

        // Eliminar el contenedor con el mensaje de que no hay comentarios
        if ($emptyDataInfo.is(":visible")) {
            $emptyDataInfo.hide();
        }

        this._commentsUtils.setThreadLineHeight();

    }

    openWritingSection() {

        const $writingSection = $("div.write-section-comment");
        const $bottomOptions = $("div.bottomOptionsButtons");
        const $documentDetailsContainer = $("#document-details-content");
        const $documentDetailsToggleButton = $("#document-details-toggle-button");
        const $commentsTab = $("#comments-tab");
        const $shareDocumentButton = $("div.copyClipboardButton ");
        const $shareInputGroup = $("#shareInputGroup");
        const $rateDocumentButton = $('#documentRate-' + documentationScreenController.currentDocumentDetails.id + '-details');
        const $rateInputGroup = $("#rateInputGroup");
        const commentsTabSelected = $("#document-details-content div.comments-tab").hasClass("active");
        const that = this;

        // Cerrar la seccion de compartir documento antes de abrir la seccion de comentarios
        if ($shareInputGroup.is(":visible")) {
            $shareDocumentButton.trigger("click");
        }

        // Cerrar la seccion de votar documento antes de abrir la seccion de comentarios
        if ($rateInputGroup.is(":visible")) {
            $rateDocumentButton.trigger("click");
        }

        if (!$documentDetailsContainer.hasClass("opened")) {
            $documentDetailsToggleButton.trigger("click");
        }

        if (!commentsTabSelected) {
            $commentsTab.trigger("click");
        }

        $writingSection.addClass("is-open");
        $writingSection.animate({bottom: $bottomOptions.height()});

        // Añadir clase para ajustar altura cuando se abre la sección de comentarios
        const $commentsTabPane = $("#document-details-content > .bf-tabs > .tab-content > .comments-tab");
        $commentsTabPane.addClass("comments-writing-open");

        const $commentBox = $("#comment-box");
        const $emojisContainer = $(".emojis-container");

        $emojisContainer.off("click.insertEmoji");
        $emojisContainer.on("click.insertEmoji", "div.emoji-button", function(e){
            const $this = $(this);
            that._commentsUtils.insertAtCaret($commentBox.attr("id"), $this.text());
            $commentBox.mentionsInput('updateValues');
        });

    }

    hideWritingSection() {

        const $writingSection = $("div.write-section-comment");
        const $replyToCommentContainer = $("div.reply-to-comment-container");
        const $replyToCommentHeader = $("div.reply-to-comment-header");
        const $mentionsTextarea = $("textarea.comment-textarea");

        $writingSection.removeClass("is-open");
        $replyToCommentHeader.removeClass("is-visible")
        $writingSection.animate({bottom: -$writingSection.outerHeight()});
        $replyToCommentContainer.html(null);
        $mentionsTextarea.mentionsInput('reset');
        $mentionsTextarea.css("height", "");

        // Remover clase para ajustar altura cuando se cierra la sección de comentarios
        const $commentsTabPane = $("#document-details-content > .bf-tabs > .tab-content > .comments-tab");
        $commentsTabPane.removeClass("comments-writing-open");

    }

    _onToggleLikeComment(event) {

        const $this = $(event.currentTarget);
        const commentId = $this.data("comment");
        const $gifCommentLiked = $("#gif-comment-liked-" +  commentId);

        // Prevenir error al pulsar varias veces seguidas y rapido sobre el boton de like.
        if ($gifCommentLiked.children().length === 0) {
            docSocket.emit(SocketEvents.SET_LIKE_COMMENT_REQUEST(), JSON.stringify({comment_id: commentId}));
        }

    }

    _onClickEditComment(event) {

        function _onSaveChanges() {

            if (!$popUpSaveChangesButton.hasClass("disabled")) {

                let commentText = "";

                $commentTextArea.mentionsInput('val', function(text) {
                    commentText = text;
                });

                const socketRequestData = {
                    comment_id: commentId,
                    comment: commentText
                };

                docSocket.emit(SocketEvents.EDIT_COMMENT_REQUEST(), JSON.stringify(socketRequestData));
                popUpController.hidePopUp();

            }

        }

        function _onDiscardChanges() {
            popUpController.hidePopUp();
        }

        function _onValidateComment() {

            if ($commentTextArea.val().length === 0) {
                $popUpSaveChangesButton.addClass("disabled");
            } else {
                $popUpSaveChangesButton.removeClass("disabled");
            }

        }

        const $this = $(event.currentTarget);
        const commentId = $this.data("comment");
        const commentData = this._commentsData.getComment(commentId);
        let commentText = "";

        if (commentData.unalteredComment) {
            commentText = commentData.unalteredComment;
        } else {
            commentText = commentData.comment;
        }

        popUpController.setPopUp(this._popUpEditCommentTemplate, {});
        popUpController.showPopUp("bottom");

        let formatComment = commentText;

        if (commentData.mentions.length > 0) {
            // Formatea el markup de las menciones al formato que utiliza la libreria para reemplazar las menciones en el texto
            _.forEach(commentData.mentions, function(mention){
                formatComment = formatComment.replaceAll("@{" + mention.id + "}", "@[" + mention.label + "](contact:" + mention.id + ")");
            });

        }

        this.enableMentions($("textarea.edit-comment-textarea"), ".edit-mentions-list-container", ".edit-mentions-list-container > .edit-mentions-results", ".friend-item.is-directory", formatComment);

        const $commentTextArea = $("div.bf-popup textarea.edit-comment-textarea");
        const $popUpSaveChangesButton = $("div.save-changes");
        const $popUpDiscardChangesButton = $("div.discard-changes");

        $commentTextArea.autogrow({vertical: true, horizontal: false});
        $popUpSaveChangesButton.on("click.saveCommentChanges", _onSaveChanges);
        $popUpDiscardChangesButton.on("click.discardCommentChanges", _onDiscardChanges);
        $commentTextArea.on("input.changeTextarea", _onValidateComment);

    }

    _onClickDeleteComment(event) {

        const $this = $(event.currentTarget);
        const commentId = $this.data("comment");
        const socketRequestData = {
            comment_id: commentId
        };

        const swalOptions = {
            title: "",
            text: Translator.trans("TR_SEGURO_QUE_QUIERES_ELIMINAR_COMENTARIO"),
            type: "warning",
            showConfirmButton: true,
            showCancelButton: true,
            closeOnConfirm: false,
            closeOnCancel: false,
            confirmButtonText: Translator.trans("TR_ELIMINAR").toUpperCase(),
            confirmButtonColor: "#F5222D",
            cancelButtonText: Translator.trans("TR_CANCELAR").toUpperCase(),
            allowEscapeKey: false
        }

        swal(swalOptions, function(confirmDelete) {

            if (confirmDelete) {
                docSocket.emit(SocketEvents.REMOVE_COMMENT_REQUEST(), JSON.stringify(socketRequestData));
            }

            swal.close();

        });

    }

    _onClickReplyToComment(event) {

        const $this = $(event.currentTarget);
        const $replyToCommentContainer = $("div.reply-to-comment-container");
        const $replyToCommentHeader = $("div.reply-to-comment-header");
        const $replyToUsername = $("div.reply-to-username");
        const $openCommentButton = $("div.openCommentButton");
        const $commentTextarea = $("textarea.comment-textarea");
        const commentId = $this.data("comment");
        const commentData = this._commentsData.getComment(commentId);
        const commentAuthor = parseInt(commentData.user_world_id) === user.user_world_id ? sprintf(Translator.trans("TR_X_TU"), commentData.username) : commentData.username;
        const quoteCommentHtml = $("div.document-comment[data-comment=" + commentId + "] > .comment-content").html();
        const responseToUserData = {
            id: commentData.author_data.user_world_id,
            name: commentData.author_data.name + " " + commentData.author_data.last_name,
            value: commentData.author_data.name + " " + commentData.author_data.last_name,
            type: "contact"
        }

        if (!$openCommentButton.hasClass("world_color_1_bg")) {
            documentationScreenController.sendDetailsComment(documentationScreenController.currentDocumentDetails);
        }

        $replyToCommentHeader.addClass("is-visible");
        $replyToUsername.html(sprintf(Translator.trans("TR_RESPONDIENDO_A_X"), "<span class='world_color_1'>" + commentAuthor + "</span>"));
        $replyToCommentContainer.html("<div class='comment-content' data-reply='" + commentId + "'>" + quoteCommentHtml + "</div>");
        $commentTextarea.mentionsInput('addMention', responseToUserData);

        this.openWritingSection();

    }

    _onClickRemoveReplyToComment(event) {

        const $replyToCommentContainer = $("div.reply-to-comment-container");
        const $replyToCommentHeader = $("div.reply-to-comment-header");

        $replyToCommentContainer.html(null);
        $replyToCommentHeader.removeClass("is-visible");

    }

    _onclickUser(event) {

        const $this = $(event.currentTarget);
        const $documentationHeaderCloseButton = $("#documentation-header-close-btn");
        const userWorldId = $this.data("user");

        if ($documentationHeaderCloseButton.length > 0 && world.profile_customization.show_opponent_profile) {
            $documentationHeaderCloseButton.hide();
        }

        api.getUserProfile(world.token, userWorldId, false);

    }

    addComment(documentId, comment, responseToCommentId) {

        const socketRequestData = {
            comment: comment,
            document_id: documentId
        }

        if (responseToCommentId) {
            socketRequestData.response_to = responseToCommentId;
        }

        docSocket.emit(SocketEvents.ADD_COMMENT_REQUEST(), JSON.stringify(socketRequestData));

    }

    editComment(commentId, editedCommentData) {

        const $commentText = $("div.document-comment[data-comment=" + commentId + "] p.comment-text");
        const commentData = this._commentsData.getComment(commentId);

        commentData.formatComment = DocumentationUtils.formatCommentMentions(editedCommentData.unalteredComment, editedCommentData.mentions, commentData.author_data.user_world_id);
        commentData.comment = editedCommentData.comment;
        commentData.unalteredComment = editedCommentData.unalteredComment;
        commentData.mentions = editedCommentData.mentions;

        $commentText.html(commentData.formatComment);

        this._commentsData.setComment(commentData);
        this._commentsUtils.setThreadLineHeight();

    }

    deleteComment(commentsIds) {

        function _removeComment(commentId) {

            const $commentThread = $(".comment-thread[data-thread=" + commentId + "]");
            const $comment = $(".document-comment[data-comment=" + commentId + "]");

            if ($commentThread.length > 0) {
                $commentThread.remove();
            } else {
                $comment.remove();
            }

            _.remove(currentCommentsList, function(comment) {
                return comment.comment_id === commentId;
            });

        }

        const currentCommentsList = this._commentsData.getCommentsList();

        _.forEach(commentsIds, _removeComment);
        this._commentsUtils.setThreadLineHeight();

    }

    initialize(commentsList) {

        this._commentsData.setCommentsList(commentsList);
        this._drawCommentsList();
        this._enableHandlers();

    }

}